<template>
  <button class="btn btn-link btn-sm order-1 order-lg-0 text-light" id="sidebarToggle" href="#">
    <font-awesome-icon icon="bars"/>
  </button>
</template>

<script>
export default {
  name: "NavToggleButton",

  /** mixins **/
  mixins: [],

  /** props **/
  props: {},

  /** data **/
  data() {
    return {}
  },

  /** methods**/
  methods: {},

  /**  computed  **/
  computed: {},

  /** mounted **/
  mounted() {
  },

  /** created **/
  created() {
  },

  /** watch
   searchText : {
			handler : 'fetchUserList',
			immediate : true,
		}
   **/
  watch: {},

  /** destroyed **/
  destroyed() {
  },

}
</script>

<style scoped>

</style>
